var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ez-table',_vm._g(_vm._b({attrs:{"headers":_vm.mergedHeaders},scopedSlots:_vm._u([_vm._l((_vm.$scopedSlots),function(_,name){return {key:name,fn:function(slotData){return [_vm._t(name,null,null,slotData)]}}})],null,true)},'ez-table',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }